// GENERATED by scripts/gen-config.mjs from testnet/deployed/deployment.json + price-sources.json. Do not edit.
import type { MarketConfig } from './types';

export const MARKET: MarketConfig = {
  "chainId": 46630,
  "rpc": "https://rpc.testnet.chain.robinhood.com",
  "explorer": "https://explorer.testnet.chain.robinhood.com",
  "deployBlock": 122684537,
  "multicall3": "0xcA11bde05977b3631167028862bE2a173976CA11",
  "pool": "0xe197b9491C3490f586fb0Fb0AAB49D4c666BA4a2",
  "poolAddressesProvider": "0x73097e1dF6E0000F26Ae10da1eda4d502f935c4d",
  "poolConfigurator": "0xB80200b445BF4815Ce5116e22725b442E9599c83",
  "aaveOracle": "0xA7DC0587ab990ac07792d1EE9d36Ab0B64FBF410",
  "protocolDataProvider": "0x3aF2e7b6409F300B1f4dd433c7372723C86486bb",
  "uiPoolDataProvider": "0xB7A8e98345C412CfD55d2B5b050e9A59BF61dd2D",
  "aclManager": "0x7FbaB255114ECC2c94F937729470A9CF103D7952",
  "treasury": "0xb2249619D8f667F3fFc125eE3F2D2A0196F69dC0",
  "interestRateStrategy": "0xc10ca897c83D1d614f9194E2b8dC7bb3384aAca9",
  "admin": "0xbf3173570F46C6dA3BcD4095A603E80c33386808",
  "keeperRouter": "0xA24C52FB839Cd32Ee6155a491E76cd1b33Ff6aCd",
  "keeper": "0x5D2b5B829A97aF36d5631FdeE6E8174459EC5Cf5",
  "stockTokens": {
    "registry": "0x0F86891402449e773495684e14Cb7466b55bF245",
    "implementation": "0x66d2bc1d5479add9879BDDEfF49c5BD04952F728",
    "faucet": "0x38d3f9BadeA7029834dA9Ec9832ca311944Cc792"
  },
  "assets": [
    {
      "symbol": "TSLA",
      "name": "Tesla (testnet stock token)",
      "address": "0xF4ebcBa2A9f2749002942507DfB27F7DE9494c0D",
      "decimals": 18,
      "role": "collateral",
      "feed": "0x1CE1ab88E71743B364B24337A0DB0b98e3790B3f",
      "adapter": "0xeacC51209FC979D074686b8b095fa2E3CdbF92Af",
      "source": {
        "type": "chainlink",
        "feed": "0x4A1166a659A55625345e9515b32adECea5547C38",
        "fallback": {
          "type": "robinhood-api",
          "symbol": "TSLA"
        }
      },
      "faucet": "stock",
      "mainnetToken": "0x322F0929c4625eD5bAd873c95208D54E1c003b2d",
      "isin": "US88160R1014"
    },
    {
      "symbol": "MSFT",
      "name": "Microsoft (testnet stock token)",
      "address": "0x85d5ad9c42799043FC0Ce68F15fBe0D2321e9ccB",
      "decimals": 18,
      "role": "collateral",
      "feed": "0x5143E400dd355182C2DF6559B8B681713dCDD424",
      "adapter": "0xf3411e201e8Ba314e1d46f9cF9275Fc23f6B2DEd",
      "source": {
        "type": "chainlink",
        "feed": "0x45C3C877C15E6BA2EBB19eA114Ea508d14C1Af2E",
        "fallback": {
          "type": "robinhood-api",
          "symbol": "MSFT"
        }
      },
      "faucet": "stock",
      "mainnetToken": "0xe93237C50D904957Cf27E7B1133b510C669c2e74",
      "isin": "US5949181045"
    },
    {
      "symbol": "AAPL",
      "name": "Apple (testnet stock token)",
      "address": "0xba4B75da9c9BeA6ca3F28d75a1A42085ff166250",
      "decimals": 18,
      "role": "collateral",
      "feed": "0x5AEAd0b0f21436Bab54dDeeDE37B5AD850949428",
      "adapter": "0xc2DB142E929bD8d4c87FFcD51f5D1425Ab36Deaf",
      "source": {
        "type": "chainlink",
        "feed": "0x6B22A786bAa607d76728168703a39Ea9C99f2cD0",
        "fallback": {
          "type": "robinhood-api",
          "symbol": "AAPL"
        }
      },
      "faucet": "stock",
      "mainnetToken": "0xaF3D76f1834A1d425780943C99Ea8A608f8a93f9",
      "isin": "US0378331005"
    },
    {
      "symbol": "AMZN",
      "name": "Amazon (testnet stock token)",
      "address": "0x4667AC92A94466316C4142872382820868639904",
      "decimals": 18,
      "role": "collateral",
      "feed": "0xcD453e6Dd27ae7502e6762b93E7285AD677F07a8",
      "adapter": "0x833B2C039cB263d3982cE6fa09032598330B3b0F",
      "source": {
        "type": "chainlink",
        "feed": "0xD5a1508ceD74c084eBf3cBe853e2C968fB2a651C",
        "fallback": {
          "type": "robinhood-api",
          "symbol": "AMZN"
        }
      },
      "faucet": "stock",
      "mainnetToken": "0x12f190a9F9d7D37a250758b26824B97CE941bF54",
      "isin": "US0231351067"
    },
    {
      "symbol": "META",
      "name": "Meta Platforms (testnet stock token)",
      "address": "0x4d94B48eC752c8636C44cF09cfb0F688CFE077Cd",
      "decimals": 18,
      "role": "collateral",
      "feed": "0x6EFa1cbbEa636340cBcaA134c16482620Bf151BC",
      "adapter": "0x5576988b2d6BDBAA2448bFFFA3b6BeBa7AaD11b9",
      "source": {
        "type": "chainlink",
        "feed": "0x7C38C00C30BEe9378381E7B6135d7283356D71b1",
        "fallback": {
          "type": "robinhood-api",
          "symbol": "META"
        }
      },
      "faucet": "stock",
      "mainnetToken": "0xc0D6457C16Cc70d6790Dd43521C899C87ce02f35",
      "isin": "US30303M1027"
    },
    {
      "symbol": "GOOGL",
      "name": "Alphabet Class A (testnet stock token)",
      "address": "0x0fe127DdeFddfd9269C6Ec42E3f3Ee49BdA9EbcD",
      "decimals": 18,
      "role": "collateral",
      "feed": "0x7D302b6f2bEe990504204e62c5FEa538B9EC5048",
      "adapter": "0x387EE59ed17fB6AB77e5FE45F64D61DB2170C713",
      "source": {
        "type": "chainlink",
        "feed": "0xF6f373a037c30F0e5010d854385cA89185AE638b",
        "fallback": {
          "type": "robinhood-api",
          "symbol": "GOOGL"
        }
      },
      "faucet": "stock",
      "mainnetToken": "0x2e0847E8910a9732eB3fb1bb4b70a580ADAD4FE3",
      "isin": "US02079K3059"
    },
    {
      "symbol": "NVDA",
      "name": "NVIDIA (testnet stock token)",
      "address": "0xb28722AFf254B00278d1561B7739666BD225da0E",
      "decimals": 18,
      "role": "collateral",
      "feed": "0x104B946B324e1c6cEbbf11E5430e7672598578A9",
      "adapter": "0xF42FaC39f4c09024B532C987ab4E9e2AC249A99B",
      "source": {
        "type": "chainlink",
        "feed": "0x379EC4f7C378F34a1B47E4F3cbeBCbAC3E8E9F15",
        "fallback": {
          "type": "robinhood-api",
          "symbol": "NVDA"
        }
      },
      "faucet": "stock",
      "mainnetToken": "0xd0601CE157Db5bdC3162BbaC2a2C8aF5320D9EEC",
      "isin": "US67066G1040"
    },
    {
      "symbol": "SPCX",
      "name": "SpaceX Class A (testnet stock token)",
      "address": "0x1cD00Eb2Fd9F54D82B996E2B391f03eEC6188bb2",
      "decimals": 18,
      "role": "collateral",
      "feed": "0x405a35b8102D989Fc72e23f67e2ee53BCAdF256c",
      "adapter": "0xbFDa77Ca68969b2d027c3AdA179D96bD8CF7e239",
      "source": {
        "type": "chainlink",
        "feed": "0xB265810950ba6c5C0Ff821c9963014a56fD8Bffb",
        "fallback": {
          "type": "robinhood-api",
          "symbol": "SPCX"
        }
      },
      "faucet": "stock",
      "mainnetToken": "0x4a0E65A3EcceC6dBe60AE065F2e7bb85Fae35eEa",
      "isin": "US84615Q1031"
    },
    {
      "symbol": "MU",
      "name": "Micron Technology (testnet stock token)",
      "address": "0xC16DeaCb11370b6F1b66703b57Cb02D7Ae250103",
      "decimals": 18,
      "role": "collateral",
      "feed": "0x7340dbcC78b8120d14822EF7442530A09Ca17433",
      "adapter": "0xbE05703d285B19e863fBeF8159F6Da82EE963993",
      "source": {
        "type": "chainlink",
        "feed": "0x425EEFdCf05ed6526C3cE61Af99429A228a6d596",
        "fallback": {
          "type": "robinhood-api",
          "symbol": "MU"
        }
      },
      "faucet": "stock",
      "mainnetToken": "0xfF080c8ce2E5feadaCa0Da81314Ae59D232d4afD",
      "isin": "US5951121038"
    },
    {
      "symbol": "SNDK",
      "name": "Sandisk (testnet stock token)",
      "address": "0xcF9f76b20F96c5F20707265B47fEDE89F6556cfb",
      "decimals": 18,
      "role": "collateral",
      "feed": "0xa5D9B53E12E4081e761CF593C05a221D323415DB",
      "adapter": "0xC3a4a2fc3409B6587156D57543f5ac37A5e3D84A",
      "source": {
        "type": "chainlink",
        "feed": "0xfb133Fa4B7b385802B693a293606682Df47109A3",
        "fallback": {
          "type": "robinhood-api",
          "symbol": "SNDK"
        }
      },
      "faucet": "stock",
      "mainnetToken": "0xB90A19fF0Af67f7779afF50A882A9CfF42446400",
      "isin": "US80004C2008"
    },
    {
      "symbol": "SKHY",
      "name": "SK hynix ADS (testnet stock token)",
      "address": "0xc76266a65CCFE65679355101131d3C7C4b870064",
      "decimals": 18,
      "role": "collateral",
      "feed": "0x7dDa919A4D250FE221984d8A90Dfb302a9cD0571",
      "adapter": "0x06f0380835e12661b8778E33f9E1037dAdB6169D",
      "source": {
        "type": "robinhood-api",
        "symbol": "SKHY",
        "mainnetToken": "0x84CAb63bc87912E71ad199ff14A0bA45de68FeF8"
      },
      "faucet": "stock",
      "mainnetToken": "0x84CAb63bc87912E71ad199ff14A0bA45de68FeF8",
      "isin": "US78392B2060"
    },
    {
      "symbol": "AMD",
      "name": "AMD (testnet stock token)",
      "address": "0xb908b4eb6d98545178ECD070ca434C9392046BD7",
      "decimals": 18,
      "role": "collateral",
      "feed": "0xAA3DF31a56A496F79cc1024A3245b0Aaae3064CD",
      "adapter": "0x3bcb5a38bFD31C5CC719E1468e71b239e8fA48Bf",
      "source": {
        "type": "chainlink",
        "feed": "0x943A29E7ae51A4798823ca9eEd2ed533B2A22C72",
        "fallback": {
          "type": "robinhood-api",
          "symbol": "AMD"
        }
      },
      "faucet": "stock",
      "mainnetToken": "0x86923f96303D656E4aa86D9d42D1e57ad2023fdC",
      "isin": "US0079031078"
    },
    {
      "symbol": "INTC",
      "name": "Intel (testnet stock token)",
      "address": "0x896Cf4861008974F72316dBDc81B9c7a22e65325",
      "decimals": 18,
      "role": "collateral",
      "feed": "0xe66Efb56199c2d5988964E92F237F67634CB2DA5",
      "adapter": "0x7979c6FAD44c7c695F062F0778f7c3342a6cFb92",
      "source": {
        "type": "chainlink",
        "feed": "0x3f390C5C24628Ac7C489515402235FeAD71D1913",
        "fallback": {
          "type": "robinhood-api",
          "symbol": "INTC"
        }
      },
      "faucet": "stock",
      "mainnetToken": "0xc72b96e0E48ecd4DC75E1e45396e26300BC39681",
      "isin": "US4581401001"
    },
    {
      "symbol": "USDG",
      "name": "Test Global Dollar (mock)",
      "address": "0x0fEe91e33b8fFE75e3f13a4B7d6da12441E52B98",
      "decimals": 6,
      "role": "borrow",
      "feed": "0x7bBf7AA053eC068Cdb770368B88531486E83E09B",
      "adapter": "0xE03fa770366B7DE9Cf54C0e7EE8aC19841aa247e",
      "source": {
        "type": "chainlink",
        "feed": "0x61B7e5650328764B076A108EFF5fa7282a1B9aD2"
      },
      "faucet": "mint",
      "mainnetToken": null,
      "isin": null
    }
  ],
  "auxFeeds": [
    {
      "symbol": "ETH",
      "feed": "0xBA98519c88DfA556C28f096ab261Ee9a009d88B1",
      "source": {
        "type": "chainlink",
        "feed": "0x78F3556b67E17Df817D51Ef5a990cDaF09E8d3A9"
      }
    }
  ],
  "mainnet": {
    "chainId": 4663,
    "rpc": "https://rpc.mainnet.chain.robinhood.com",
    "rpcs": [
      "https://rpc.mainnet.chain.robinhood.com",
      "https://robinhood-rpc.publicnode.com",
      "https://robinhood.drpc.org",
      "https://rpc.ordofi.network"
    ]
  },
  "testnetRpcs": [
    "https://rpc.testnet.chain.robinhood.com",
    "https://robinhood-sepolia-rpc.publicnode.com",
    "https://robinhood-testnet.drpc.org"
  ],
  "quoteApi": "https://api.robinhood.com/rhj/prices/",
  "assetsApi": "https://api.robinhood.com/rhj/assets",
  "privyAppId": "cmuc3k8ex009i0bjyxveum2gg"
};
